<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item><i class="el-icon-lx-cascades"></i> 洗选数据平台功能设置</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="container" style="height: 850px">
        <div class="divB">
            <el-form :inline="true" ref="mineNumberArr" :model="mineNumberArr">
                <!-- <el-card shadow="hover" style="height:65px;">
                    <el-form-item label="生成洗选产品数质量日报表:" style="margin-bottom:-30px">
                        <el-switch v-model="isReportGeneration" active-text="是" inactive-text="否" @change="changeReportGeneration()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item style="margin-left:30px;margin-bottom:-200px" label="每天">
                        <el-select v-model="mineNumberArr.reportGenerationTime" class="size-full" style="width:80px">
                            <el-option v-for="item in ReportGenerationTime" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="点生成">
                        <el-button type="primary" @click="saveTime('reportGenerationTime')">确 定</el-button>
                    </el-form-item>
                </el-card> -->
                <el-card shadow="hover" style="height:350px;">
                    <div>
                        <span>洗选数据联网数据平台设置</span>
                    </div>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item label="服务器IP:" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.ip" placeholder="服务器IP" style="width:100px"></el-input>
                        </el-form-item>
                        <el-form-item label="端口:" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.port" placeholder="服务器端口" style="width:60px"></el-input>
                        </el-form-item>
                        <el-form-item style="margin-left:30px">
                            <el-button type="primary" @click="saveEdit('MineNumber')">确 定</el-button>
                        </el-form-item>
                    </el-card>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item label="开启洗选数据联网数据上传:" style="margin-left:3px;margin-bottom:-200px">
                            <el-switch v-model="isCoalWashDataUpload" active-text="是" inactive-text="否" @change="changeWashDataUpload()" style="margin-top:5px" />
                        </el-form-item>
                    </el-card>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item label="生成洗选数据联网数据上传记录:" style="margin-left:3px;margin-bottom:-200px">
                            <el-switch v-model="isCoalWashDataUploadLog" active-text="是" inactive-text="否" @change="changeWashDataUploadLog()" style="margin-top:5px" />
                        </el-form-item>
                        <el-form-item style="margin-left:30px">
                            <el-button type="primary" @click="UpLog('MineNumber')">上传记录查询</el-button>
                        </el-form-item>
                    </el-card>
                </el-card>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import router from '../../router';
export default {
    name: 'mineNumberArr',
    data() {
        return {
            mineNumberArr: {
                id: '',
                ip: '',
                isCoalWashDataUpload: 0,
                isCoalWashDataUploadLog: 0,
                isCoalWashDataReview: 0,
                reportGenerationTime: 16,
                password: '',
                port: '',
                username: '',
            },
            isCoalWashDataUpload: true,
            isCoalWashDataUploadLog: true,
            isCoalWashDataReview: true,
            balanceArr: [],
            ReportGenerationTime: [{
                name: '0点',
                value: 0
            }, {
                name: '1',
                value: 1
            }, {
                name: '2',
                value: 2
            }, {
                name: '3',
                value: 3
            }, {
                name: '4',
                value: 4
            }, {
                name: '5',
                value: 5
            }, {
                name: '6',
                value: 6
            }, {
                name: '7',
                value: 7
            }, {
                name: '8',
                value: 8
            }, {
                name: '9',
                value: 9
            }, {
                name: '10',
                value: 10
            }, {
                name: '11',
                value: 11
            }, {
                name: '12',
                value: 12
            }, {
                name: '13',
                value: 13
            }, {
                name: '14',
                value: 14
            }, {
                name: '15',
                value: 15
            }, {
                name: '16',
                value: 16
            }, {
                name: '17',
                value: 17
            }, {
                name: '18',
                value: 18
            }, {
                name: '19',
                value: 19
            }, {
                name: '20',
                value: 20
            }, {
                name: '21',
                value: 21
            }, {
                name: '22',
                value: 22
            }, {
                name: '23',
                value: 23
            }, ],
        };
    },
    created() {
        this.getSystemInfo();
    },
    methods: {
        getSystemInfo() {
            var serach = {};
            this.$zybhttp
                .get('Business/GetCoalWashDataConfigInfor', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.version = d.msg;
                        this.mineNumberArr.id = d.data.list[0].id;
                        this.mineNumberArr.ip = d.data.list[0].ip;
                        this.mineNumberArr.port = d.data.list[0].port;
                        this.mineNumberArr.username = d.data.list[0].userName;
                        this.mineNumberArr.password = d.data.list[0].passWord;
                        this.mineNumberArr.isCoalWashDataUpload = d.data.list[0].isCoalWashDataUpload;
                        this.mineNumberArr.isCoalWashDataUploadLog = d.data.list[0].isCoalWashDataUploadLog;
                        this.mineNumberArr.isCoalWashDataReview = d.data.list[0].isCoalWashDataReview;
                        this.isCoalWashDataUpload = d.data.list[0].isCoalWashDataUpload == 1 ? true : false;
                        this.isCoalWashDataUploadLog = d.data.list[0].isCoalWashDataUploadLog == 1 ? true : false;
                        this.isCoalWashDataReview = d.data.list[0].isCoalWashDataReview == 1 ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        saveEdit() {
            this.$refs['mineNumberArr'].validate((valid) => {
                if (valid) {
                    this.$zybhttp
                        .post('SystemInfo/SetCoalWashDataConfigInfor', this.mineNumberArr)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success('修改成功');
                                this.getSystemInfo();
                            } else {
                                this.$notify.error('修改失败');
                            }
                        })
                        .catch((err) => this.$notify.error('网络异常！修改失败'));

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        changeWashDataUpload() {
            this.mineNumberArr.isCoalWashDataUpload = this.isCoalWashDataUpload ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetCoalWashDataConfigInfor', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeWashDataUploadLog() {
            this.mineNumberArr.isCoalWashDataUploadLog = this.isCoalWashDataUploadLog ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetCoalWashDataConfigInfor', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        UpLog() {
            this.$router.push('CoalWashDataUploadRecord')
        },
    }
};
</script>

<style scoped>
.divA {
    float: left;
    width: 30%;
    /* border: 1px solid #fbacce; */
}

.divB {
    float: left;
    width: 48%;
    /* border: 1px solid #fbacce; */
    margin-left: 30px;
}

.divB div,
h3 {
    margin-bottom: 30px;
}

.size-full {
    width: 100%;
}
</style>
